package fr.xibalba.generateurClassesLycee

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import fr.xibalba.generateurClassesLycee.eleves.Eleve
import fr.xibalba.generateurClassesLycee.eleves.loadEleves
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable

@OptIn(DelicateCoroutinesApi::class)
object GlobalData {
    var fichier by mutableStateOf<Fichier?>(null) // Subject to user input
        private set
    val rawPatchesMap: MutableMap<Int, String> = mutableMapOf() // Subject to user input
    val editedFichierContent
        get() = getEditedFichierContent()
    var loadedFichier by mutableStateOf<LoadedFichier?>(null) // Not subject to user input
        private set

    init {
        GlobalScope.launch {
            val fichier = loadFileFromIndexedDB()
            if (fichier != null) {
                val rawPatches = loadRawPatchesFromIndexedDB(fichier.hashCode().toHexString())
                if (rawPatches != null) {
                    rawPatchesMap.putAll(rawPatches)
                }
                _setFichier(fichier)
            }
        }
    }

    fun setFichier(newFichier: Fichier?) {
        if (newFichier == null) {
            GlobalScope.launch {
                deleteFileFromIndexedDB()
            }
        } else {
            GlobalScope.launch {
                saveFileToIndexedDB(newFichier)
            }
        }
        _setFichier(newFichier)
    }

    private fun _setFichier(newFichier: Fichier?) {
        fichier = newFichier
        reloadEleves()
    }

    private fun reloadEleves() {
        if (editedFichierContent != null && fichier != null) {
            val data = loadEleves(editedFichierContent!!, fichier!!.hasHeader)
            loadedFichier = LoadedFichier(
                goodEleves = data.first,
                errorLines = data.second
            )
        } else {
            loadedFichier = null
        }
    }

    private fun getEditedFichierContent(): List<String>? {
        return fichier?.content?.lines()?.mapIndexed { index, line ->
            rawPatchesMap[index] ?: line
        }
    }

    fun submitNewPatches(newPatches: Map<Int, String>) {
        for ((lineNumber, newValue) in newPatches) {
            rawPatchesMap[lineNumber] = newValue
        }
        GlobalScope.launch {
            saveRawPatchesToIndexedDB(fichier.hashCode().toHexString(), rawPatchesMap)
        }
        reloadEleves()
    }
}

@Serializable
data class Fichier(val name: String, val content: String, val hasHeader: Boolean)

data class LoadedFichier(
    val goodEleves: List<Eleve>,
    val errorLines: List<Int>
)